import { formatPhoneNumber } from "../../Common/utils/universalFuntions";

export const getCombinedAgentsData = ({ getIndividualTransactionData = {}, agentData = [], agentList = [], agentType = "", origin = "" }) => {
  if (Array.isArray(agentData) && agentData.length > 0) {
    const mappedFromAgentDocs = agentData?.map((agent) => {
      const profileImg = agent?.profileImg?.original || agent?.profileImg?.thumbnail || "";
      const phoneNumber = agent?.mobilePhoneNumber?.phoneNumber || agent?.phoneNumber || "";
      const countryCode = agent?.mobilePhoneNumber?.countryCode || "";
      return {
        _id: agent._id || agent.personId || undefined,
        personId: agent._id || agent.personId || undefined,
        fullName: agent.fullName || [agent.firstName, agent.middleName, agent.lastName].filter(Boolean).join(" ").trim() || "",
        email: agent.email || "",
        phoneNumber,
        countryCode,
        profileImg,
      };
    });
    agentList.push(...mappedFromAgentDocs);
  }
  const transactionData = getIndividualTransactionData?.newTransactionData || getIndividualTransactionData || {};

  const sourceAgents = Array.isArray(transactionData?.[agentType]) ? transactionData[agentType] : [];
  if (!sourceAgents?.length) return agentList;
  sourceAgents.forEach((el) => {
    if (el?.personId?.length !== 24) {
      agentList.push(el);
    }
  });
  return agentList;
};

export const getCombinedTitleCompanyData = ({ getIndividualTransactionData, source }) => {
  const titleRepsData = [];
  const affiliatesData = [];

  const titleDetails = getIndividualTransactionData?.titleCompanyDetails;

  if (titleDetails && ["SELLING_RTD", "CONTRACT_NAV_BUYER_AGENT", "CONTRACT_NAV_SELLER_AGENT"].includes(source)) {
    // Adding Sales Rep and Title Closer
    if (titleDetails.salesRepName?.trim() && titleDetails.salesRepEmail?.trim()) {
      titleRepsData.push({
        fullName: titleDetails.salesRepName?.trim() || "",
        email: titleDetails.salesRepEmail?.trim() || "",
        _id: `${titleDetails.salesRepName?.toLowerCase().replace(/\s+/g, "") || ""}-${titleDetails.salesRepEmail?.toLowerCase() || ""}`,
      });
    }
     // Adding Title Closer
    if (titleDetails.titleCloserName?.trim() && titleDetails.titleCloserEmail?.trim()) {
      titleRepsData.push({
        fullName: titleDetails.titleCloserName?.trim() || "",
        email: titleDetails.titleCloserEmail?.trim() || "",
        _id: `${titleDetails.titleCloserName?.toLowerCase().replace(/\s+/g, "") || ""}-${titleDetails.titleCloserEmail?.toLowerCase() || ""}`,
      });
    }

    // Adding Processors
    titleDetails.processors?.forEach((processor) => {
      if (processor?.name?.trim() && processor?.email?.trim()) {
        titleRepsData.push({
          fullName: processor.name.trim(),
          email: processor.email.trim(),
          _id: processor._id || "",
        });
      }
    });

    // Adding Affiliates
    titleDetails.affiliateDetails?.affiliates?.forEach((affiliate) => {
      if (affiliate?.name?.trim() && affiliate?.email?.trim()) {
        affiliatesData.push({
          fullName: affiliate.name.trim(),
          email: affiliate.email.trim(),
          _id: affiliate._id || "",
        });
      }
    });
  }

  return { titleRepsData, affiliatesData };
};


export const prepareCurrentAgentDetails = ({ currentAgentDetails = {}, contractType }) => {
  const agentArray = [
    {
      personId: currentAgentDetails?._id || null,
      fullName: currentAgentDetails?.fullName || "",
      email: currentAgentDetails?.email || "",
      resureFirmId: currentAgentDetails?.brokerageData?.resureFirmId || "",
      firmName: currentAgentDetails?.brokerageData?.name?.trim() || "",
      firmLicense: currentAgentDetails?.brokerageData?.licenseNumber || "",
      license: currentAgentDetails.licenseId || "",
      address: currentAgentDetails?.brokerageData?.address || "",
      ...(contractType === "DC_ADBA" && { labelType: "DESIGNATED_BROKER" }), 
      phoneNumber: formatPhoneNumber(currentAgentDetails?.mobilePhoneNumber?.phoneNumber || ""),
      officePhoneNumber: formatPhoneNumber(currentAgentDetails?.brokerageData?.phoneNumber || ""),
      faxNumber: formatPhoneNumber(currentAgentDetails?.brokerageData?.faxNumber || "", "FAX"),
    },
  ];

  return {  agentArray };
};

export const steetAddressDetailsPrepare = ({ addressData }) => {
  if (typeof addressData !== "object") {
    return {};
  }
  return {
    StreetNumber: addressData?.StreetNumber || "",
    StreetName: addressData?.StreetName || "",
    DirPrefix: addressData?.DirPrefix || "",
    DirSuffix: addressData?.DirSuffix || "",
    StreetSuffix: addressData?.StreetSuffix || "",
    UnitLabel: addressData?.UnitLabel || "",
    UnitNumber: addressData?.UnitNumber || "",
    City: addressData?.City || "",
    State: addressData?.State || "",
    ZipCode: addressData?.ZipCode || "",
  };
};
